import { isString } from "ramda-adjunct";
import React, { useCallback } from "react";
import { useLanguageSelected } from "@sinch/components/form/MultilanguageTextInput/LanguageSelectedProvider";

export const useLanguageTabs = ({
  initialLanguage,
  inputRef,
}: {
  initialLanguage: string;
  inputRef: React.RefObject<HTMLInputElement | null>;
}) => {
  const [selectedLang, setSelectedLang] = useLanguageSelected(initialLanguage);

  const handleTabChange = useCallback(
    (newLangOverride: React.SyntheticEvent | string, newLang?: string) => {
      setSelectedLang(isString(newLangOverride) ? newLangOverride : (newLang ?? ""));
      // Use RAF to ensure the state update is processed before focusing
      requestAnimationFrame(() => {
        inputRef.current?.focus();
      });
    },
    [inputRef]
  );

  const handleTabMouseDown = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
  }, []);

  return { selectedLang, onLangSelect: handleTabChange, onMouseDown: handleTabMouseDown };
};
